var _rect, _g, _circle, _path, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDkk(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 26,
    fill: "#313131"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -20,
    y: -101,
    width: 192,
    height: 232,
    rx: 20,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_1",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 26
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.6743,
    r: 12.5,
    fill: "#F4F4F5"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_1)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_0_1",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 26
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.174316H25V25.1743H0V0.174316Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.174316H25V25.1743H0V0.174316Z",
    fill: "#F4F4FC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 0.174316V10.1743H0V0.174316H10ZM15 0.174316H25V10.1743H15V0.174316ZM25 15.1743V25.1743H15V15.1743H25ZM10 25.1743H0V15.1743H10V25.1743Z",
    fill: "#DB0033"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 13.6743H11.5V25.1743H13.5V13.6743H25V11.6743H13.5V0.174316H11.5V11.6743H0V13.6743Z",
    fill: "#F4F4FC"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_1",
    x: -40,
    y: -117,
    width: 232,
    height: 272,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0462899 0 0 0 0 0.0394965 0 0 0 0 0.379167 0 0 0 0.45 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 254,
    height: 290,
    fill: "white",
    transform: "translate(-53 -131)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDkk);
export default __webpack_public_path__ + "static/media/DKK.0df92397ee011bbe910f335d9153011c.svg";
export { ForwardRef as ReactComponent };